export default {
  settings: {
    currentLogo: "Logo actuel",
    logo: "Logo",
    paginationSize: "Taille de pagination",
    paginationHint: "Nombre d’éléments affichés par page.",
    notify:{
      errorFetchText: "Impossible de charger les paramètres",
      sucessSaveText: "Paramètres sauvegardés",
      errorSaveText:"Erreur lors de la sauvegarde",
    }
  }
}
